export default "__VITE_ASSET__Iy7if3Lg__"